import styled, { keyframes, css } from "styled-components";
import { MdKeyboardArrowRight, MdArrowForward } from "react-icons/md";
export { MdKeyboardArrowRight, MdArrowForward };

export const HeroContainer = styled.div`
  background: #0c0c0c;
  display: block;
  padding: 0;
  height: calc(100vh - 80px);
  position: relative;
  z-index: 1;

  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: -webkit-gradient(
        linear,
        left top,
        left bottom,
        from(rgba(0, 0, 0, 0.2)),
        to(rgba(0, 0, 0, 0.2))
      ),
      -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.2)), to(transparent));
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.2) 0%,
        rgba(0, 0, 0, 0.6) 100%
      ),
      linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, transparent 100%);
    z-index: 2;
  }
`;

export const HeroBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const VideoBg = styled.video`
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  background: #232a34;
`;

export const HeroContent = styled.div`
  z-index: 3;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: relative;
`;

export const HeroH1 = styled.h1`
  color: #fff;
  font-size: 48px;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 40px;
  }

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const HeroP = styled.p`
  margin-top: 24px;
  color: #fff;
  font-size: 24px;
  text-align: center;
  max-width: 600px;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;
export const HeroBtnWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: row; // Changed from column to row
  align-items: center;
  justify-content: center;
`;

export const ArrowForward = styled(MdArrowForward)`
  margin-left: 8px;
  font-size: 20px;
`;

export const ArrowRight = styled(MdKeyboardArrowRight)`
  margin-left: 8px;
  font-size: 20px;
`;

export const GearBtn = styled.button`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-size: 20px;
  transition: background 0.2s, transform 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: rotate(45deg);
  }
`;

const waveAnim = keyframes`
  0%, 100% { transform: scaleY(0.25); }
  50%       { transform: scaleY(1); }
`;

export const WaveBar = styled.span`
  display: block;
  width: 3px;
  border-radius: 2px;
  transform-origin: bottom;
  background: ${({ $active }) => ($active ? "#22c55e" : "#ef4444")};
  height: ${({ $h }) => $h}px;
  ${({ $active, $delay }) =>
    $active
      ? css`
          animation: ${waveAnim} 0.7s ease-in-out ${$delay}s infinite;
        `
      : ""}
`;

export const WaveIconWrap = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 2px;
  height: 18px;
`;

export const VoicePanel = styled.div`
  position: fixed;
  top: 66px;
  right: 16px;
  z-index: 9999;
  background: #1a1a2e;
  border: 1px solid rgba(167, 139, 250, 0.4);
  border-radius: 12px;
  padding: 16px;
  min-width: 260px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.8);
  color: #fff;

  h4 {
    margin: 0 0 12px;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: rgba(255, 255, 255, 0.6);
  }

  select {
    width: 100%;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    color: #fff;
    padding: 8px 10px;
    font-size: 13px;
    cursor: pointer;
    outline: none;
    appearance: none;

    option {
      background: #1a1a2e;
      color: #fff;
    }

    &:hover {
      border-color: rgba(255, 255, 255, 0.4);
    }
  }

  label {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 12px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.55);

    input[type="range"] {
      accent-color: #a78bfa;
      width: 100%;
    }
  }
`;
